import { normalizeColor } from 'utils/colors'

/**
 * Resolve @color references (e.g. @primary, @secondary) inside
 * a backgroundGradient object to actual color values.
 */
export const resolveGradientColors = (obj, branding) => {
  if (!obj?.backgroundGradient) return obj
  const bg = obj.backgroundGradient

  return {
    ...obj,
    backgroundGradient: {
      ...bg,
      startColor: bg.startColor
        ? normalizeColor(bg.startColor, branding)
        : bg.startColor,
      endColor: bg.endColor
        ? normalizeColor(bg.endColor, branding)
        : bg.endColor,
    },
  }
}

/**
 * Force-disable a backgroundGradient so the component
 * falls back to its solid primaryColor.
 */
export const disableGradient = obj => {
  if (!obj?.backgroundGradient) return obj

  return {
    ...obj,
    backgroundGradient: { ...obj.backgroundGradient, enabled: false },
  }
}
